import { render, staticRenderFns } from "./ProductsSelectList.vue?vue&type=template&id=34ffe8d8&scoped=true&"
import script from "./ProductsSelectList.vue?vue&type=script&lang=js&"
export * from "./ProductsSelectList.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSelectList.vue?vue&type=style&index=0&id=34ffe8d8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ffe8d8",
  null
  
)

export default component.exports